var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{ref:"btn",on:{"click":_vm.handler}},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }